module.exports = __webpack_public_path__ + "img/cover29.a3e98afd.png";